"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isImageEvent = exports.isImageLoadEvent = exports.renderMessage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const message_1 = __importDefault(require("./message"));
const renderMessage = (onRedoClick) => (message) => {
    return ((0, jsx_runtime_1.jsx)(message_1.default, { message: message, onRedoClick: onRedoClick }, `${message.id}_${message.label}`));
};
exports.renderMessage = renderMessage;
const isImageLoadEvent = (e) => e.type === "load" && e.target instanceof HTMLImageElement;
exports.isImageLoadEvent = isImageLoadEvent;
const isImageEvent = (e) => {
    return ((e.type === "error" || e.type === "load") &&
        e.target instanceof HTMLImageElement);
};
exports.isImageEvent = isImageEvent;
//# sourceMappingURL=Messages.js.map